module.exports = __webpack_public_path__ + "img/turning.e7d98269.png";